import OtherTransactionExpenses from "./OtherTransactionExpenses";

export default OtherTransactionExpenses;